import React from 'react'

import Theme from '@HOCs/ThemeProvider'

export const wrapRootElement = ({ element }) => <Theme>{element}</Theme>
